module.exports = __webpack_public_path__ + "img/R06_05.f8b0acfb.svg";